export class FileWrapper {

    id = 0;
    displayName: string | null = null;
    fileName: string | null = null;

    file: File | null = null;

    constructor() {}

    setFile(file: File) {
        this.file = file;
        this.displayName = file.name;
    }
}